/**
 * C-03 · Pesos y método de consolidación por versión
 * (`/api/versiones/{id}/configuracion`).
 *
 * Sustituye a los pesos 0.30/0.35/0.35 que antes estaban cableados en la UI. Las
 * tres ponderaciones deben sumar 100, y el backend rechaza el guardado si no
 * cuadran.
 *
 * Capa de servicios: una función por operación del API. No lanza nunca —cada
 * función devuelve un valor neutro ante el fallo—, así que el llamador debe
 * comprobar el resultado, no envolver en try/catch.
 */

import { http, HttpResult } from '@/services/http'
import type { GradoMaam } from '@/utils/consolidacion'

/** Forma con la que el API de configuracion evaluacion devuelve este dato. */
export interface ConfiguracionEvaluacion {
  id?: number
  id_version: number
  metodo_consolidacion: 'ponderado' | 'simple'
  ponderacion_documental: number
  ponderacion_cuantitativa: number
  ponderacion_opinion: number
}

/**
 * Consulta configuracion evaluacion · `GET /api/versiones`.
 *
 * @returns HttpResult<ConfiguracionEvaluacion>
 */
export function getConfiguracionVersionService(
  idVersion: number
): Promise<HttpResult<ConfiguracionEvaluacion>> {
  return http.get<ConfiguracionEvaluacion>(`/api/versiones/${idVersion}/configuracion`)
}

/**
 * Actualiza configuracion evaluacion · `PUT /api/versiones`.
 *
 * @returns HttpResult<ConfiguracionEvaluacion>
 */
export function updateConfiguracionVersionService(
  idVersion: number,
  payload: Partial<ConfiguracionEvaluacion>
): Promise<HttpResult<ConfiguracionEvaluacion>> {
  return http.put<ConfiguracionEvaluacion>(`/api/versiones/${idVersion}/configuracion`, payload)
}

/** C-04: catálogo único de grados MAAM. */
export function getGradosMaamService(): Promise<HttpResult<GradoMaam[]>> {
  return http.get<GradoMaam[]>('/api/grados')
}
